import * as React from "react";
import { ReactNode } from "react";

import { cn } from "@/lib/utils";
import TextareaAutosize from "react-textarea-autosize";

export interface MultilineInputProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

const MultilineInput = React.forwardRef<
  HTMLTextAreaElement,
  MultilineInputProps
>(({ className, startIcon, endIcon, style: _textAreaStyle, ...props }, ref) => {
  return (
    <div className="relative w-full">
      {startIcon && (
        <div className="absolute left-1.5 top-1/2 -translate-y-1/2 transform">
          {startIcon}
        </div>
      )}
      <TextareaAutosize
        className={cn(
          "placeholder:text-muted-foreground flex min-h-10 w-full rounded-md border border-input bg-background px-4 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
          startIcon ? "pl-8" : "",
          endIcon ? "pr-8" : "",
          "resize-none",
          "[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
          className,
        )}
        ref={ref}
        rows={1}
        maxRows={6}
        {...props}
      />
      {endIcon && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 transform">
          {endIcon}
        </div>
      )}
    </div>
  );
});
MultilineInput.displayName = "MultilineInput";

export { MultilineInput };
